// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"6f6226e1","581":"6f6226e1","8049":"6f6226e1","9504":"6f6226e1"}[chunkId] + ".chunk.css";
};